// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2670":"e937333dea865613d645","2739":"f31e41a2854a7fc73ebc","2888":"9c64e5e7dbd505fa00d5","4495":"f31e41a2854a7fc73ebc"}[chunkId] + ".css";
};